import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { CookieIcon } from "lucide-react";
import { CookiePreferencesDialog } from "./CookiePreferencesDialog";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

export const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);

  useEffect(() => {
    const checkCookieConsent = () => {
      const consent = localStorage.getItem('cookieConsent');
      if (!consent) {
        setShowBanner(true);
        return;
      }

      const { timestamp } = JSON.parse(consent);
      const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
      if (Date.now() - timestamp > thirtyDaysInMs) {
        localStorage.removeItem('cookieConsent');
        setShowBanner(true);
      }
    };

    checkCookieConsent();
  }, []);

  const saveCookiePreference = async (preferences: any) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        await supabase
          .from('profiles')
          .update({
            cookie_preferences: preferences
          })
          .eq('id', user.id);
      }
      
      localStorage.setItem('cookieConsent', JSON.stringify({
        preferences,
        timestamp: Date.now()
      }));
      
      setShowBanner(false);
      toast.success("Préférences de cookies enregistrées");
    } catch (error) {
      console.error("Erreur lors de l'enregistrement des préférences:", error);
      toast.error("Erreur lors de l'enregistrement des préférences");
    }
  };

  const handleAcceptAll = () => {
    saveCookiePreference({
      necessary: true,
      analytics: true,
      marketing: true
    });
  };

  const handleRejectAll = () => {
    saveCookiePreference({
      necessary: true,
      analytics: false,
      marketing: false
    });
  };

  if (!showBanner) return null;

  return (
    <>
      <div className="fixed bottom-4 left-4 right-4 md:left-8 md:right-auto md:max-w-md bg-white rounded-lg shadow-lg p-6 z-50 border">
        <div className="flex items-start gap-4">
          <CookieIcon className="h-6 w-6 flex-shrink-0 text-gray-500" />
          <div className="space-y-3">
            <p className="text-sm text-gray-600">
              Nous utilisons des cookies pour améliorer votre expérience. 
              Vous pouvez gérer vos préférences à tout moment.
            </p>
            <div className="flex flex-wrap gap-2">
              <Button 
                size="sm" 
                onClick={handleAcceptAll}
              >
                Accepter tout
              </Button>
              <Button 
                size="sm"
                variant="outline" 
                onClick={handleRejectAll}
              >
                Refuser tout
              </Button>
              <Button
                size="sm"
                variant="ghost"
                onClick={() => setShowPreferences(true)}
              >
                Personnaliser
              </Button>
            </div>
          </div>
        </div>
      </div>
      <CookiePreferencesDialog 
        open={showPreferences} 
        onOpenChange={setShowPreferences}
      />
    </>
  );
};